
import Board from '@/components/Board.vue'
import WorkspaceSideMenu from '@/components/WorkspaceSideMenu.vue'
import CreateNewBoard from '@/components/CreateNewBoard.vue'
import ActionButton from '@/components/ActionButton.vue'
import WorkspaceTitle from '@/components/WorkspaceTitle.vue'
import { defineComponent } from 'vue'
export default defineComponent({
  components: {
    Board,
    WorkspaceTitle,
    WorkspaceSideMenu,
    CreateNewBoard,
    ActionButton
  },
  inject: ['starredBoards', 'recentBoards', 'workspace']
})
